import {
  AGILE_PURCHASE_TRADED_PRODUCTS,
  AGILE_PURCHASE_TRADED_PRODUCTS_SUCCESS,
  AGILE_PURCHASE_TRADED_PRODUCTS_ERROR,
  AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS,
  AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS_SUCCESS,
  AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS_ERROR
} from './AgilePurchaseTradedProducts.actions'
const initialState = {
  data: [],
  options: [],
  loading: false,
  error: null
}
/**
 * Agile Purchase Product's reducer.
 */
const agilePurchaseTradedProductsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case AGILE_PURCHASE_TRADED_PRODUCTS:
      return { ...state, data: [], loading: true }
    case AGILE_PURCHASE_TRADED_PRODUCTS_ERROR:
      return { ...state, loading: false, error: payload.error, data: [] }
    case AGILE_PURCHASE_TRADED_PRODUCTS_SUCCESS:
      return { ...state, data: payload.data, loading: false }
    case AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS:
      return { ...state, search: [], loading: true }
    case AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS_ERROR:
      return { ...state, loading: false, error: payload.error, search: [] }
    case AGILE_PURCHASE_TRADED_SEARCH_PRODUCTS_SUCCESS:
      return { ...state, ...payload, loading: false }
    default:
      return state
  }
}

export default agilePurchaseTradedProductsReducer
